import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { promise } from 'protractor';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ExtremeWeatherDataService {

  constructor(private http: HttpClient,
    private utilService: UtilsService,
    private datePipe: DatePipe

  ) { }

  getWindData(url){
    let dataPromise = new Promise((resolve,reject) => {
      this.http.get(url).subscribe(
        data=>{
          let obj = this.setWindData(data);
          resolve(obj);
        }
      )
    })
    return dataPromise;
  }

  getDefaultSourceFromSourceList(sourceList,forecastLength){
    for(let index in sourceList){
        let sourceInfo = sourceList[index];
        if(sourceInfo['forecastLengthList'].indexOf(forecastLength) > -1){
          return sourceInfo['source']
        }
    }
}

  getHeatMap(url){
    let dataPromise = new Promise((resolve,reject) =>{
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
      });
    });
  return dataPromise;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  setWindData(data) {
    for (let block of Object.keys(data)) {
      let array = [];
      let obj1 = new Object();
      obj1['header'] = {
        "parameterUnit": "m.s-1",
        "parameterNumber": 2,
        "dx": 0.5,
        'dy': 0.5,
        "parameterNumberName": "eastward_wind",
        "la1": 40.0,
        "la2": 5.0,
        'parameterCategory': 2,
        "lo2": 100.0,
        "nx": 71,
        "ny": 71,
        "refTime": "2017-02-01 23:00:00",
        "lo1": 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      let obj2 = {};
      obj2["header"] = {
        "parameterUnit": "m.s-1",
        "parameterNumber": 3,
        "dx": 0.5,
        "dy": 0.5,
        "parameterNumberName": "eastward_wind",
        "la1": 40.0,
        "la2": 5.0,
        "parameterCategory": 2,
        "lo2": 100.0,
        "nx": 71,
        "ny": 71,
        "refTime": "2017-02-01 23:00:00",
        "lo1": 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }

  getForecastFileTimeStamp(primarySource,secondarySource) {
    let url = ProjConstants.API_URL + ProjConstants.API_MAPPING['FORECASTFILES'] + '/' + primarySource + "/" + secondarySource;
    let promise = new Promise((resolve,reject)=> {
      this.http.get(url).subscribe(data=>{
        let max = data[primarySource];
        for(let source in data){
          if(max==undefined || Number(data[source]) > max){
           max = Number(data[source]) 
          }
        }
        resolve(max.toString())
      })
    }) 
    return promise
  }
  formatStateData(data){
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for(let locName in data){
      let locObject = {}
      locObject['State'] = { val : this.utilService.formatNames(data[locName]['name'])};
      locObject['uuid'] =  data[locName]['uuid'];
      for(let element in data[locName]['table_data']){
        if(data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined){
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if(!timeStampList.includes(timeStamp)){
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "c";
        locObject[timeC] = { val : data[locName]['table_data'][element]['data']['c']};
        let timeD = timeStamp.toString() + "_" + "d";
        locObject[timeD] = { val : data[locName]['table_data'][element]['data']['d']};
      }
      // console.log(data[locName]);
      if(data[locName]['centroid'] != undefined && data[locName]['centroid'] != null){
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val : 'State / UT',
      colspan : 1,
      rowspan : 2,
      sortedHeaderVal : 'State',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val :'State'});
    for(let index in sortedTimeStampList){
      let tp = sortedTimeStampList[index];
      column1.push({
        val : this.utilService.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan : 2,
        rowspan : 1,
        sortedHeaderVal : tp.toString() + "_d"
      })
      column2.push({
        val : 'Heatwave',
        colspan : 1,
        rowspan : 1,
        backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        sortedHeaderVal : tp.toString() + "_c"
      })
      column2.push({
        val : 'Severe Heatwave',
        colspan : 1,
        rowspan : 1,
        backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
        sortedHeaderVal : tp.toString() + "_d"
      })
      tableHeaders.push({
        val : tp.toString() + "_c"
      })
      tableHeaders.push({
        val : tp.toString() + "_d"
      })
    }
    let tableColumns  = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatDistrictData(data){
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for(let locName in data){
      let locObject = {}
      locObject['District'] = { val : this.utilService.formatNames(data[locName]['name'])};
      locObject['uuid'] = (data[locName]['uuid']);
      for(let element in data[locName]['table_data']){
        if(data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined){
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if(!timeStampList.includes(timeStamp)){
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "c";
        locObject[timeC] = { val : data[locName]['table_data'][element]['data']['c']};
        let timeD = timeStamp.toString() + "_" + "d";
        locObject[timeD] = { val : data[locName]['table_data'][element]['data']['d']};
      }
      // console.log(data[locName]);
      if(data[locName]['centroid'] != undefined && data[locName]['centroid'] != null){
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val : 'District',
      colspan : 1,
      rowspan : 2,
      sortedHeaderVal : 'District',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val :'District'});
    for(let index in sortedTimeStampList){
      let tp = sortedTimeStampList[index];
      column1.push({
        val : this.utilService.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan : 2,
        rowspan : 1,
        sortedHeaderVal : tp.toString() + "_d"
      })
      column2.push({
        val : 'Heatwave',
        colspan : 1,
        rowspan : 1,
        backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        sortedHeaderVal : tp.toString() + "_c"
      })
      column2.push({
        val : 'Severe Heatwave',
        colspan : 1,
        rowspan : 1,
        backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
        sortedHeaderVal : tp.toString() + "_d"
      })
      tableHeaders.push({
        val : tp.toString() + "_c"
      })
      tableHeaders.push({
        val : tp.toString() + "_d"
      })
    }
    let tableColumns  = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatTimestampWithOffset(timestamp) {
    // Extract the year, month, and day from the timestamp
    const year = timestamp.substring(0, 4); // "2024"
    const monthIndex = parseInt(timestamp.substring(4, 6), 10) - 1; // "12" -> December (0-based index)
    const day = parseInt(timestamp.substring(6, 8), 10); // "19"
  
    // Create a date object in UTC
    const date = new Date(Date.UTC(year, monthIndex, day));
  
    // Adjust for GMT +5:30 (5 hours 30 minutes)
    const offsetMinutes = 5 * 60 + 30;
    date.setUTCMinutes(date.getUTCMinutes() + offsetMinutes);
  
    // Get the day, month, and year
    const formattedDay = String(date.getUTCDate()).padStart(2, '0'); // e.g., "19"
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formattedMonth = monthNames[date.getUTCMonth()]; // e.g., "Dec"
    const formattedYear = date.getUTCFullYear(); // e.g., "2024"
  
    // Combine into the desired format with GMT+5:30
    return `${formattedDay}-${formattedMonth}-${formattedYear} GMT+5:30`;
  }

  getCurrentBlockTs(dayStartTs) {
    let currentTs = new Date().getTime()
    let blockTs = dayStartTs;
    let timeStamp;
    for (let i = 0; i < 8; i++) {
      if (blockTs <= currentTs) {
        timeStamp = blockTs;
      } else {
        break;
      }
      blockTs = blockTs + 10800000;
    }
    return timeStamp

  }

}

